import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'react-oidc-context';
import { Container } from '../common/container.styles';
import {
  Header,
  Wrapper,
  Section,
  Descriptions,
  ButtonWrapper,
  TextWrapper,
  ImageWrapperDesktop,
  ImageWrapperMobile,
} from './authentication.styles';
import authentication_car_desktop from '../../../assets/main-page/authentication/authentication_car_desktop.webp';
import authentication_car_mobile from '../../../assets/main-page/authentication/authentication_car_mobile.webp';

import { useStore } from '../../../stores/store';
import Button from '../../../common/button/button.component';
import { useIsMobile } from '../../../hooks/use-is-mobile.hook';
import { generateMyRoute } from '../../../utils/uri/uri.utils';
import { AppRoute } from '../../../constants/route';

const AuthenticationComponent = () => {
  const {
    userStore: { user, loginGup },
  } = useStore();

  const auth = useAuth();

  const isMobile = useIsMobile();

  const { t } = useTranslation();

  if (user) return null;

  return (
    <Container>
      <Section>
        <Wrapper>
          <TextWrapper>
            <Header>{t('still_dont_have_an_account')}</Header>
            <Descriptions>{t('register_signin_to_get_benefits')}</Descriptions>
          </TextWrapper>
          {isMobile && (
            <ImageWrapperMobile>
              <img
                width={319}
                height={254}
                src={authentication_car_mobile}
                alt=''
              />
            </ImageWrapperMobile>
          )}
          <ButtonWrapper>
            <Button
              fullWidth={false}
              size='large'
              onClick={() =>
                loginGup({
                  auth,
                  redirectUri: generateMyRoute(AppRoute.PARCEL_LIST),
                })
              }>
              {t('create_account')}
            </Button>
            <Button
              fullWidth={false}
              appearance='secondary'
              size='large'
              onClick={() =>
                loginGup({
                  auth,
                  redirectUri: generateMyRoute(AppRoute.PARCEL_LIST),
                })
              }>
              {t('sign_in')}
            </Button>
          </ButtonWrapper>
          <ImageWrapperDesktop>
            <img
              width={480}
              height={292}
              decoding='async'
              loading='lazy'
              src={authentication_car_desktop}
              alt=''
            />
          </ImageWrapperDesktop>
        </Wrapper>
      </Section>
    </Container>
  );
};

export default observer(AuthenticationComponent);
